class YoniqCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-yoniq-track]');
    this.slides = Array.from(this.querySelectorAll('[data-yoniq-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-yoniq-dot]'));
    this.previousButton = this.querySelector('[data-yoniq-previous]');
    this.nextButton = this.querySelector('[data-yoniq-next]');
    this.index = 0;
    this.timer = null;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!this.track || this.slides.length < 1) return;

    this.onPrevious = () => this.show(this.index - 1, true);
    this.onNext = () => this.show(this.index + 1, true);
    this.onKeydown = (event) => {
      if (event.key === 'ArrowLeft') this.onPrevious();
      if (event.key === 'ArrowRight') this.onNext();
    };
    this.onVisibilityChange = () => {
      if (document.hidden) this.stop();
      else this.start();
    };

    this.previousButton?.addEventListener('click', this.onPrevious);
    this.nextButton?.addEventListener('click', this.onNext);
    this.addEventListener('keydown', this.onKeydown);
    this.addEventListener('pointerenter', () => this.stop());
    this.addEventListener('pointerleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
    document.addEventListener('visibilitychange', this.onVisibilityChange);

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.show(index, true));
    });

    this.show(0, false);
    this.start();
  }

  disconnectedCallback() {
    this.stop();
    this.previousButton?.removeEventListener('click', this.onPrevious);
    this.nextButton?.removeEventListener('click', this.onNext);
    this.removeEventListener('keydown', this.onKeydown);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  }

  show(nextIndex, announce = false) {
    const slideCount = this.slides.length;
    this.index = (nextIndex + slideCount) % slideCount;
    this.track.style.setProperty('--yoniq-slide-index', this.index);

    this.slides.forEach((slide, index) => {
      const isActive = index === this.index;
      slide.setAttribute('aria-hidden', String(!isActive));
      slide.querySelectorAll('a, button').forEach((element) => {
        element.tabIndex = isActive ? 0 : -1;
      });
    });

    this.dots.forEach((dot, index) => {
      const isActive = index === this.index;
      dot.toggleAttribute('aria-current', isActive);
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
    });

    if (announce) {
      const status = this.querySelector('[data-yoniq-status]');
      if (status) status.textContent = `Slide ${this.index + 1} of ${slideCount}`;
    }
  }

  start() {
    this.stop();
    if (this.dataset.autoplay !== 'true' || this.reduceMotion.matches || this.slides.length < 2) return;

    const interval = Number(this.dataset.interval) || 5200;
    this.timer = window.setInterval(() => this.show(this.index + 1), interval);
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  }
}

if (!customElements.get('yoniq-carousel')) {
  customElements.define('yoniq-carousel', YoniqCarousel);
}
